export default __webpack_public_path__ + "static/media/nero.656d56ec.jpg";